'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _onlinepbxQuestion = require('./onlinepbx-question');

var _onlinepbxQuestion2 = _interopRequireDefault(_onlinepbxQuestion);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTextareaAutosize = require('react-textarea-autosize');

var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);

var _onlinepbxWarning = require('./onlinepbx-warning');

var _onlinepbxWarning2 = _interopRequireDefault(_onlinepbxWarning);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OnlinepbxTextarea = function (_React$Component) {
  _inherits(OnlinepbxTextarea, _React$Component);

  function OnlinepbxTextarea(props) {
    _classCallCheck(this, OnlinepbxTextarea);

    var _this = _possibleConstructorReturn(this, (OnlinepbxTextarea.__proto__ || Object.getPrototypeOf(OnlinepbxTextarea)).call(this, props));

    _this.state = {
      isFocus: false
    };
    return _this;
  }

  _createClass(OnlinepbxTextarea, [{
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            label = _props.label,
            placeholder = _props.placeholder,
            _props$value = _props.value,
            value = _props$value === undefined ? '' : _props$value,
            questionText = _props.questionText,
            _onChange = _props.onChange,
            _props$errorText = _props.errorText,
            errorText = _props$errorText === undefined ? '' : _props$errorText,
            maxLength = _props.maxLength,
            minHeight = _props.minHeight,
            maxHeight = _props.maxHeight,
            height = _props.height,
            disabled = _props.disabled,
            _onFocus = _props.onFocus,
            _onBlur = _props.onBlur;

        return _react2['default'].createElement(
          'div',
          { className: 'onlinepbx__lib__textarea__wrapper' },
          _react2['default'].createElement(
            'div',
            { className: 'onlinepbx__lib__textarea' },
            _react2['default'].createElement(_reactTextareaAutosize2['default'], {
              ref: function () {
                function ref(tag) {
                  _this2.textarea = tag;
                }

                return ref;
              }(),
              disabled: disabled,
              placeholder: placeholder || '',
              className: (0, _classnames2['default'])('onlinepbx__lib__textarea__field', {
                'onlinepbx__lib__textarea__field__error': !!errorText,
                'onlinepbx__lib__textarea__field__placeholder__hidden': label && !value && !this.state.isFocus,
                'onlinepbx__lib__textarea__field__disabled': disabled
              }),
              value: value,
              maxLength: maxLength,
              style: _extends({}, minHeight && { minHeight: minHeight + 'px' }, maxHeight && { maxHeight: maxHeight + 'px' }, height && { height: height + 'px' }),
              onFocus: function () {
                function onFocus(evt) {
                  _this2.setState({ isFocus: true });
                  typeof _onFocus === 'function' && _onFocus(evt);
                }

                return onFocus;
              }(),
              onBlur: function () {
                function onBlur(evt) {
                  _this2.setState({ isFocus: false });
                  typeof _onBlur === 'function' && _onBlur(evt);
                }

                return onBlur;
              }(),
              onChange: function () {
                function onChange(evt) {
                  return typeof _onChange === 'function' && _onChange(evt);
                }

                return onChange;
              }()
            }),
            label && _react2['default'].createElement(
              'div',
              {
                className: (0, _classnames2['default'])('onlinepbx__lib__textarea__label__head', {
                  'onlinepbx__lib__textarea__label__head__focus': this.state.isFocus || value
                }),
                onClick: function () {
                  function onClick() {
                    if (_this2.textarea) _this2.textarea._rootDOMNode.focus();
                  }

                  return onClick;
                }()
              },
              _react2['default'].createElement(
                'div',
                { className: (0, _classnames2['default'])('onlinepbx__lib__textarea__label', {
                    'onlinepbx__lib__textarea__label__focus': this.state.isFocus || value,
                    'onlinepbx__lib__textarea__label__disabled': disabled,
                    'onlinepbx__lib__textarea__label__error': !!errorText
                  }) },
                label
              )
            ),
            (questionText || errorText) && _react2['default'].createElement(
              'div',
              { className: 'onlinepbx__lib__textarea__extra' },
              questionText && _react2['default'].createElement(_onlinepbxQuestion2['default'], {
                right: 150,
                text: questionText
              }),
              errorText && _react2['default'].createElement(_onlinepbxWarning2['default'], {
                right: 150,
                text: errorText
              })
            )
          )
        );
      }

      return render;
    }()
  }]);

  return OnlinepbxTextarea;
}(_react2['default'].Component);

exports['default'] = OnlinepbxTextarea;